/** Default visible columns in left-to-right display order (table schema order can differ). */
export const INVITE_LANDLORD_TABLE_DEFAULT_VISIBLE_KEYS = [
  'select',
  'name',
  'email_address',
  'create_date',
  'total_buildings',
  'total_units',
  'action',
];

/** Bump when default columns/order change so persisted prefs reset. */
export const INVITE_LANDLORD_TABLE_STORAGE_KEY = 'company-invite-list-v3';
